module.exports = __webpack_public_path__ + "img/find.a7d7c21c.png";